import { ButtonProps, Button, Spinner } from '@fluentui/react-components';
import { useState, LegacyRef, MouseEvent, forwardRef } from 'react';

type TButtonLoadingProps = ButtonProps & {
  loading?: boolean;
};
const ButtonLoading = forwardRef(({ loading = false, ...props }: TButtonLoadingProps, ref) => {
  const [working, setWorking] = useState(false);
  if (props.onClick) {
    const oldOnClick = props.onClick;
    props.onClick = async (
      event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent> & MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>
    ) => {
      setWorking(true);
      try {
        await oldOnClick(event);
      } finally {
        setWorking(false);
      }
    };
  }

  if (!props.disabled && (loading || working)) {
    props.icon = <Spinner size="tiny" />;
    props.disabled = true;
  }

  return <Button {...props} ref={ref as LegacyRef<HTMLButtonElement> | undefined} />;
});

export { ButtonLoading };
